import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { IqacHeadingRoutingModule } from './iqacheading-routing.module';
import { IqacheadingListComponent } from './iqacheading-list/iqacheading-list.component';
import { IqacheadingCreateComponent } from './iqacheading-create/iqacheading-create.component';

@NgModule({
  declarations: [IqacheadingListComponent, IqacheadingCreateComponent],
  imports: [
    CommonModule,
    IqacHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class IqacHeadingModule { }
